<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="650">
      <v-card>
        <v-card-title>
          Настройки полигона
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                class="btn__icon pa-0"
                width="18"
                height="18"
                @click="close"
              >
                <v-icon size="x-large">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card-title>
        <div class="colors-polygon">
          <div style="flex: 1; text-align: center;">
            <label>Цвет линии</label>
            <v-color-picker hide-inputs flat v-model="color" @input="onColorChange()"></v-color-picker>
          </div>
          <div style="flex: 1; text-align: center;">
            <label>Цвет заливки</label>
            <v-color-picker hide-inputs v-model="fillColor" @input="onFillColorChange()"></v-color-picker>
          </div>
        </div>
        <div style="display: flex; align-items: center;">
          <v-text-field
            v-model="name"
            type="string"
            class="mb-2 pa-3"
            clearable
            outlined
            dense
            hide-details
            label="Название полигона">
          </v-text-field>
          <v-text-field
            v-model="comment"
            type="string"
            class="mb-2 pa-3"
            clearable
            outlined
            dense
            hide-details
            label="Комментарий">
          </v-text-field>
        </div>
        <div style="text-align: right; margin-right: 20px;">
          <v-btn
            style="margin-bottom: 35px"
            color="primary"
            @click="toggleSelection"
          >
            Создать
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      searchValue: '',
      comment: '',
      name: '',
      menu: false,
      color: '#de8a98',
      fillColor: '#3388ff',
    };
  },
  methods: {
    toggleSelection () {
      if (this.name === '') {
        this.$flash_danger('Укажите название полигона');
        return;
      }
      this.$emit('toggleSelection', this.name, this.comment);
    },
    onColorChange () {
      this.$emit('onColorChange', this.color);
    },
    onFillColorChange () {
      this.$emit('onFillColorChange', this.fillColor);
    },
    async close () {
      await this.$emit('close');
      this.reset();
    },
    reset () {
      setTimeout(() => {
        this.comment = '';
        this.name = '';
        this.color = '#de8a98';
        this.fillColor = '#3388ff';
      }, 400);
    },
  },
};
</script>

<style lang="scss">
.color-picker {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.colors-polygon {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

.color-swatch {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin-right: 8px;
}

@media screen and (max-width: 680px) {
  .colors-polygon {
    display: block;
  }
}
</style>
